import { useEffect, useRef } from "react";
import "./CardPage.scss";
import gsap from "gsap";
import { useQuery } from "@tanstack/react-query";
import { getUser } from "../../api/user";
import StatsHeader from "../../components/card/StatsHeader";
import AltarCard from "../../components/card/AltarCard";

function CardPage() {
    const pageRef = useRef(null);

    const {data: user, isLoading: userIsLoading} = useQuery({
        queryKey: ["user"],
        queryFn: getUser,
    });

    const isLoading = userIsLoading;

    useEffect(() => {
        pageRef.current && gsap.fromTo(pageRef.current,
            {opacity: 0, scale: 1.01, y: -10},
            {opacity: 1, scale: 1, y: 0, duration: .5, ease: "power2.out"}
        );
    }, [isLoading]);

    return (
        !isLoading && <div className="card-page-wrapper" ref={pageRef}>
            <div className="card-page">
                <div className="card-page-header">
                    <StatsHeader user={user} />
                </div>
                
                <div className="page-get-card">
                    <AltarCard />
                </div>
            </div>
        </div>
    );
};

export default CardPage;